var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "449.77344pt",
    height: "50.65625pt",
    viewBox: "0 0 449.77344 50.65625",
    id: "svg16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs16"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g17",
    transform: "translate(-68.09375,-598.37109)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#939598",
    fillOpacity: 1,
    d: "M 517.67969,598.55859 507,619.92187 v -21.36328 z m 0,0",
    id: "path5"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#939598",
    fillOpacity: 1,
    d: "m 517.67969,598.55859 v 21.36328 H 507 Z m 0,0",
    id: "path6"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#939598",
    fillOpacity: 1,
    d: "M 79.078125,598.55859 68.28125,619.92187 v -21.36328 z m 0,0",
    id: "path7"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#939598",
    fillOpacity: 1,
    d: "m 79.078125,598.55859 v 21.36328 H 68.28125 Z m 0,0",
    id: "path8"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#939598",
    fillOpacity: 1,
    d: "M 507,598.55859 79.078125,619.92187 v -21.36328 z m 0,0",
    id: "path9"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "#939598",
    fillOpacity: 1,
    d: "m 507,598.55859 v 21.36328 H 79.078125 Z m 0,0",
    id: "path10"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 91.041667,798.07813 H 676 V 826.5625 H 91.041667",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path11"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 676,826.5625 h 14.23958 V 798.07813 H 676 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path12"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 105.4375,826.5625 v -28.48437 28.48437 -28.48437 z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "M 105.4375,798.07813 H 91.041667 V 826.5625 H 105.4375 Z m 0,0",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path14"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 690.23958,826.5625 v 28.47917 l -10.07812,10.07813",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path15"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    strokeWidth: 0.5,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    stroke: "#000000",
    strokeOpacity: 1,
    strokeMiterlimit: 10,
    d: "m 91.041667,826.5625 v 28.47917 l 10.078123,10.07813 h 579.04167",
    transform: "matrix(0.75,0,0,0.75,0,-4e-6)",
    id: "path16"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg);
export default __webpack_public_path__ + "static/media/Ворота.a038dce76fb837c33c7bd0c4151c4c34.svg";
export { ForwardRef as ReactComponent };